<div mat-dialog-title>
    <h2>{{ data.label | locale }}</h2>
</div>

<mat-dialog-content>
    <app-datepicker
        [formGroup]="formGroup"
        name="date"
        [displayIcon]="false"
        [maximumDate]="data.maxDate"
        customDateDisplay="DD/MM/YYYY">
    </app-datepicker>

    <mat-calendar
        [headerComponent]="customHeader"
        [(selected)]="calendarDate"
        [maxDate]="data.maxDate"
        (selectedChange)="selectedDate($event)">
    </mat-calendar>
</mat-dialog-content>

<mat-dialog-actions>
    <button
        mat-flat-button
        color="primary"
        (click)="onSubmit.emit(date.value)">
        {{ 'default_button_next' | locale }}
        <mat-icon iconPositionEnd svgIcon="east" class="east"></mat-icon>
    </button>
</mat-dialog-actions>
